import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function Activities() {
  const {
    t
  } = useLanguage();
  const activities = [{
    title: t('Pesca Deportiva', 'Sport Fishing'),
    description: t('Dina Huapi es reconocida por tener uno de los mejores parajes de la provincia para la pesca con mosca en la desembocadura del río Limay.', 'Dina Huapi is known for having one of the best spots in the province for fly fishing at the mouth of the Limay River.'),
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ff8c5bab-b3e3-421b-9f72-3272c74e4856.jpg'
  }, {
    title: t('Trekking y Caminatas', 'Trekking and Hiking'),
    description: t('Senderos entre montañas y ríos para todos los niveles, desde paseos familiares hasta ascensos exigentes.', 'Trails through mountains and rivers for all levels, from family walks to demanding ascents.'),
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
  }, {
    title: t('Deportes Acuáticos', 'Water Sports'),
    description: t('Viento ideal en el lago Nahuel Huapi para practicar kitesurf, windsurf o disfrutar de un tranquilo paseo en kayak.', 'Ideal wind on Lake Nahuel Huapi for kitesurfing, windsurfing, or enjoying a peaceful kayak ride.'),
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/518072f1-f04a-4f6b-ae57-ad272a12ebfc.jpg'
  }, {
    title: t('Cabalgatas', 'Horseback Riding'),
    description: t('Recorridos guiados por la estepa patagónica y los bosques, una forma única de conectar con la naturaleza.', 'Guided tours through the Patagonian steppe and forests, a unique way to connect with nature.'),
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/68efb4f9-cd14-4787-adbc-6f2a1814f558.jpg'
  }];
  return <section id="actividades" className="py-24 bg-white" data-id="element-23" data-mp="jh5gwx70u5ix">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24" data-mp="nktohfvnl146">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-25" data-mp="ni7kfq7z13qp">
          <div className="max-w-2xl" data-id="element-26" data-mp="9mnb9mi1nzwh">
            <span className="text-accent font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-27" data-mp="ej3wa7ty5y5c">
              {t('Para hacer', 'Things to do')}
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-primary mb-4" data-id="element-28" data-mp="12bkfwmtc1y6r">
              {t('Aventura en la puerta de tu cabaña', "Adventure at your cabin's door")}
            </h2>
            <p className="text-gray-600 text-lg font-light" data-id="element-29" data-mp="xhyanfpi0wkz">
              {t('Dina Huapi y Bariloche tienen todo para vivir la Patagonia, a pocos minutos.', 'Dina Huapi and Bariloche have everything to experience Patagonia, just minutes away.')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-30" data-mp="3anmthe62twah">
          {activities.map((activity, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative overflow-hidden rounded-2xl aspect-[16/9] sm:aspect-[2/1] md:aspect-[16/9]" data-id="element-31" data-mp="35oa9d16lb3bl" data-mpi={index}>
              <img src={activity.image} alt={activity.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-32" data-mp="2vu9xmggsyztw" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent flex flex-col justify-end p-6 md:p-8" data-id="element-33" data-mp="16c4l5lkrxoab">
                <h3 className="text-xl md:text-2xl font-serif text-white mb-2" data-id="element-34" data-mp="1bbr2o77mxqox">
                  {activity.title}
                </h3>
                <p className="text-white/80 text-sm md:text-base font-light max-w-lg opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300" data-id="element-35" data-mp="1gcezxamgj3rl">
                  {activity.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}